var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('collective-detail',{attrs:{"breadcrumb-route":"subcommunities","item-type":"subcommunities","item-type-single":"subcommunity"}})}
var staticRenderFns = []

export { render, staticRenderFns }